export const safeLocalStorage = {
    getItem(key: string): string | null {
        try {
            return window.localStorage?.getItem(key) ?? null;
        } catch {
            return null;
        }
    },

    setItem(key: string, value: string): void {
        try {
            window.localStorage?.setItem(key, value);
        } catch {
            // Storage can be unavailable in privacy modes; keep the app usable.
        }
    },

    removeItem(key: string): void {
        try {
            window.localStorage?.removeItem(key);
        } catch {
            // Storage can be unavailable in privacy modes; keep the app usable.
        }
    },
};
